import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "type-2tcTe",
  "use": "type-2tcTe-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"type-2tcTe\"><path d=\"M4 7V4h16v3M9 20h6M12 4v16\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol